interface IProps {
  handleOnClick?: () => void;
  fillColor?: string;
  strokeColor?: string;
}

export const Star = ({
  fillColor,
  strokeColor = "#329EE2",
  handleOnClick,
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill={fillColor || "none"}
      onClick={handleOnClick}
    >
      <g clip-path="url(#clip0_14950_75231)">
        <path
          d="M25.5 2.14298L32.2568 14.9494L32.4862 15.3843L32.9707 15.4681L47.2383 17.9368L37.1466 28.3203L36.8039 28.6729L36.8739 29.1596L38.935 43.4917L25.9412 37.1026L25.5 36.8857L25.0588 37.1026L12.065 43.4917L14.1261 29.1596L14.1961 28.6729L13.8534 28.3203L3.76168 17.9368L18.0293 15.4681L18.5138 15.3843L18.7432 14.9494L25.5 2.14298Z"
          stroke={strokeColor}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_14950_75231">
          <rect
            width="50"
            height="50"
            fill={fillColor || "white"}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
